/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import * as actiontype from './store/actiontypes';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  closeTab,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  API_TIMEOUT_ERROR,
  FAIL_PROCESSING_REQUEST,
  SUCCESSMESSAGE_PRICE,
} from '../../../../SharedModules/Errors/constantMessageData';
import { arSummaryColumns } from '../tablehead';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';
import { getAllManufacturerDetail } from '../../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import ActionDropDownComp, { NameTooltipComp } from '../ActionDropdownComp';
import { goToArSummaryMfg } from '../ARCommonFunctions';
import { getArSummarySigleRpc } from './store/actions';
import RedTextRenderComp from '../RedTextRenderComp';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const ArSummaryByMfgAll = (props) => {
  const dispatch = useDispatch();
  const [load, setLoad] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [pinned, setPinned] = React.useState([]);
  const [programCd, setProgramCd] = React.useState();

  const { ar_tbl, qtr_val, sgl_tbl } = useSelector(
    (state) => state?.sharedState?.ArSmryMfgAllReducer
  );
  const { err_list = [] } = useSelector(
    (state) => state?.sharedState?.AccountRecReducer || {}
  );

  const frameworkComponents = {
    FullNameRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return <NameTooltipComp data={cellInfo} />;
    },

    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    actionRenderer: (cellInfo) => {
      return (
        <ActionDropDownComp
          data={cellInfo}
          loadfn={setLoad}
          displayBy="mfg"
          selectPgm
          selectedRebate={selectedRebate}
          extraData={qtr_val}
        />
      );
    },
  };

  const renderTooltip = (propsTooltip) => {
    return qtr_val?.qtrInfo.indexOf('DRAMS') !== -1 ||
      qtr_val?.qtrInfo.indexOf('First') !== -1 ? (
      <Tooltip id="add-tooltip" {...propsTooltip}>
        {qtr_val?.qtrInfo}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  const selectedRebate = (val) => {
    setProgramCd(val.rebateProgramCd);
    const payload = {
      planType: qtr_val.planType,
      startQtr: qtr_val.startQtr,
      endQtr: qtr_val.endQtr,
      useOfficialURA: qtr_val.useOfficialURA,
      allRebateProgramIndicator: 0,
      allMfgIndicator: qtr_val.allMfgIndicator,
      rebateProgramCode: val.rebateProgramCd,
      mfgId: qtr_val.mfgId,
    };
    const data = {
      ...payload,
      pgmInfo: `${val.rebateProgramCd} | ${val.shortDescr}`,
      pgmCd: val.rebateProgramCd,
      qtrInfo: qtr_val.qtrInfo,
    };
    dispatch(getArSummarySigleRpc(payload, data));
  };
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (filterApply) {
      const data = [
        {
          baseStateAmountDue: sum('baseStateAmountDue'),
          disputesAmt: sum('disputesAmt'),
          interestDue: sum('interestDue'),
          mfgId: '',
          mfgName: 'Totals:',
          offsetDue: sum('offsetDue'),
          sumInvoiceBalance: sum('sumInvoiceBalance'),
          totalBalance: sum('totalBalance'),
          unAllocatedBalance: sum('unAllocatedBalance'),
          actions: 'hide',
          isBottomRow: true,
        },
      ];
      setPinned([...data]);
    } else {
      const data = [
        {
          baseStateAmountDue: ar_tbl?.totalBaseStateAmountDue,
          disputesAmt: ar_tbl?.finalTotaldisputedAmount,
          interestDue: ar_tbl?.finalTotalInterestDue,
          mfgId: '',
          mfgName: 'Totals:',
          offsetDue: ar_tbl?.totalOffsetDue,
          sumInvoiceBalance: ar_tbl?.totalSumInvoiceBalance,
          totalBalance: ar_tbl?.finalTotalBalance,
          unAllocatedBalance: ar_tbl?.totalUnAllocatedBalance,
          actions: 'hide',
          isBottomRow: true,
        },
      ];
      setPinned([...data]);
    }
  }, [filterApply, filteredRows]);

  React.useEffect(() => {
    if (sgl_tbl) {
      if (sgl_tbl.message === 'Success' && sgl_tbl.status === '001') {
        goToArSummaryMfg(props.history, programCd, dispatch);
        dispatch({ type: actiontype.AR_SGL_TBL_DATA, payload: null });
      }
    }
  }, [sgl_tbl]);

  React.useEffect(() => {
    if (err_list.length > 0) {
      if (
        err_list?.[0] === API_TIMEOUT_ERROR ||
        err_list?.[0] === FAIL_PROCESSING_REQUEST
      ) {
        setLoad(false);
      }
    }
  }, [err_list]);

  let firstInfo = `Rebate Program: All | All Rebate Programs`;
  let secondInfo = `Quarter: ${qtr_val?.qtrInfo}`;

  return (
    <div className="tabs-container ARScreen" data-testid="ArSummaryByMfgAll">
      <Spinner load={load} />
      <CustomSeparator parent1="Research" parent2="AR Summary By Mfg" />
      <DisplaySuccessMessages successMessages={[]} />
      <ErrorMessages errorMessages={err_list} />
      {!fullScreen && (
        <div className="">
          <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
            <div className="row">
              <div className="col-12 col-sm-6 col-md-4">
                <div className="mui-custom-form">
                  <TextField
                    id="rebatepgm"
                    label="Rebate Program"
                    inputProps={{
                      id: 'rebatepgm',
                    }}
                    InputLabelProps={{ shrink: true }}
                    value="All | All Rebate Programs"
                    disabled
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="mui-custom-form">
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <TextField
                      id="qtrrange"
                      label="Quarter Range"
                      inputProps={{
                        id: 'qtrrange',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={
                        qtr_val?.qtrInfo.indexOf('DRAMS') !== -1 ||
                        qtr_val?.qtrInfo.indexOf('First') !== -1
                          ? `${qtr_val?.qtrInfo?.substring(0, 20)}...`
                          : qtr_val?.qtrInfo
                      }
                      disabled
                    />
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      )}
      <div className="frr-log_chk">
        <TableGrid
          data-testid="manufacture-grid"
          gridHeight={fullScreen ? '70vh' : 400}
          rowData={ar_tbl?.listOfTempMarSummary || []}
          columnDefs={arSummaryColumns}
          fileName="AR Summary By Mfg"
          frameworkComponents={frameworkComponents}
          // onSelectionChanged={onSelectionChanged}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          isScrollOn
          fullScreenView={fullScreen}
          handleFullScreenViewClick={() => setFullScreen(!fullScreen)}
          pinnedBottomRowData={
            ar_tbl?.listOfTempMarSummary &&
            ar_tbl?.listOfTempMarSummary?.length > 0
              ? pinned
              : undefined
          }
          info={{ firstInfo, secondInfo }}
          hideColumnsInPdf={['actions']}
          exportFile
          suppressCellFocus
          onCellFocused={onCellFocused}
          getFilterApply={getFilterApply}
          onFilterData={onFilterChanged}
          // helpMessage={Constants.DOUBLE_CLICK_INFO}
          // cellClickedListener={cellClickedListener}
        />
      </div>
    </div>
  );
};

export default ArSummaryByMfgAll;
